import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {isValidEmail} from '../../shared-modules/login/change-password/password-validator';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {LoginService} from '../../shared-modules/login/login.service';
import {UserService} from '../user/user.service';
import {Router} from '@angular/router';
import {LoginSettings} from '../../shared-modules/login/loginSetting.model';
import {User} from '../user/user.model';
import {ChangeEmailMessageComponent} from './change-email-message/change-email-message.component';
import {map} from 'rxjs/operators';
import {SharedService} from '../shared.service';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.css']
})
export class ChangeEmailComponent implements OnInit {
  LoginSettings: LoginSettings;
  User: User;
  currentEmail: string;
  repeatNewEmail: string;
  dialogBox: MatDialogRef<ChangeEmailMessageComponent>;
  newEmailError = 'Invalid email format';
  newEmail: string;
  repeatNewEmailError = 'Invalid email format';
  changeEmailForm: FormGroup;
  constructor( private dialogRef: MatDialogRef<ChangeEmailComponent>,
               private loginService: LoginService,
               private sharedService: SharedService,
               private dialog: MatDialog,
               private userService: UserService,
               private router: Router) { }

  ngOnInit() {
    this.User = this.userService.currentUser;
    this.currentEmail = this.User.Email;
    this.LoginSettings = this.loginService.LoginSettings;
    this.changeEmailForm = new FormGroup({
      'currentEmail': new FormControl({value: this.currentEmail, disabled: true},   [
        Validators.required,
      ]),
      'newEmail': new FormControl(null, [
        Validators.required,
        isValidEmail(),
      ]),
      'repeatNewEmail': new FormControl(null, [
        Validators.required
      ])
    });
    this.onChanges();
  }

  onChanges(): void {
    this.changeEmailForm.valueChanges.subscribe(val => {
      this.newEmail = val['newEmail'];
      this.repeatNewEmail = val['repeatNewEmail'];
      // Trim the leading and trailing spaces
      if (this.newEmail != null) {
        this.newEmail = this.newEmail.trim();
      }
      if (this.repeatNewEmail != null) {
        this.repeatNewEmail = this.repeatNewEmail.trim();
      }
      // check new Email
      if (this.changeEmailForm.controls.newEmail.invalid) {
        if (this.changeEmailForm.controls.newEmail.errors.hasOwnProperty('notValidEmail')) {
          this.newEmailError = 'Invalid email format';
        }
      }
      // Check Repeat New Email
      if (this.repeatNewEmail !== this.newEmail) {
        this.changeEmailForm.controls['repeatNewEmail'].setErrors({invalid: true});
        this.changeEmailForm.setErrors({invalid : true});
        this.repeatNewEmailError = 'Emails do not match';
      }
    });
  }

  closeClick() {
    // POST: the change password dialog is closed
    this.dialogRef.close();
  }

  saveClick() {
    if (!this.changeEmailForm.invalid) {
      if (this.User.Email == this.User.UserName) {
        this.showNotice().subscribe(
          result => {
            if (result) {
              this.saveEmail();
            }
          }
        );
      } else {
        this.saveEmail();
      }
    }
  }

  saveEmail() {
    this.userService.canUserChangeEmail(this.newEmail).subscribe(userCanChange => {
      if (!userCanChange) {
        this.sharedService.showCustomSnackbar('Email is already in use', 'failure');
      }
      else {
        this.userService.setUserEmail(this.newEmail).subscribe(res => {
          if (res.body) {
            this.User.Email = this.newEmail;
            // Close the modal and show a snack bar
            this.dialogRef.close();
            this.sharedService.showGoodSnackbar();
          } else {
            this.sharedService.showBadSnackbar();
          }
        });
      }
    });
  }

  showNotice () {
    // POST; shows the notice about changing email when it is your username
    this.dialogBox = this.dialog.open(ChangeEmailMessageComponent, {
      disableClose: true
    });
    this.dialogBox.componentInstance.dialogBox = this.dialogBox;
    return this.dialogBox.componentInstance.confirmEvent.pipe(map(result => {
      return result;
    }));
  }

}
